var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "flex gap-2 items-center" },
    [
      _c(
        "jade-button",
        {
          attrs: {
            size: "medium",
            variant: "neutral-ghost",
            icon: "circle-help",
          },
          on: { click: _vm.handleShowHelpCenter },
        },
        [_vm._v(" " + _vm._s(_vm.$t("general.help")) + " ")]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }